// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"d2d64a01","273":"fce62bf6","453":"a944d156","722":"cf664910"}[chunkId] + ".chunk.js";
};